import Dialog from "@components/Dialog"
import { Box, CircularProgress } from "@mui/material"
import { useCallback } from "react"

interface Props {
  open: boolean
}

const ImportProgressDialog = (props: Props) => {
  const onDialogClose = useCallback(() => {
    // This is a noop to prevent closing the dialog while import is running
  }, [])

  return (
    <Dialog
      disableEscapeKeyDown={true}
      open={props.open}
      showCloseButton={false}
      title="Importing graph"
      onClose={onDialogClose}
    >
      <Box alignItems="center" display="flex" flexDirection="column" justifyContent="center">
        <CircularProgress />
      </Box>
    </Dialog>
  )
}

export default ImportProgressDialog
